import { decodeJwt } from '../secrets/decodeJwt'

const jwtValidate = token => {
  const data = decodeJwt(process.env.REACT_APP_ORDER_KEY_H512_PEM)(token)

  const now = Date.now() / 1000
  if (data.exp > now) {
    return data
  } else {
    return undefined
  }
}

export default jwtValidate
